import { AvatarGroup, Box, Tooltip } from "@mui/material";
import { TooltipProps, styled, tooltipClasses } from "@mui/material";
import { FONT_FAMILY } from "../../theme";
import { NavLink } from "react-router-dom";
import { styles } from "../../pages/Tracks/styles";
import { StyledProfilePic } from "../ExploreBase/styles";
import { collaboratorsStyles } from "./styles";
import { Collaborator } from "../../proto/api_pb";

export const CustomizedTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: "white",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    borderRadius: 10,
    fontFamily: FONT_FAMILY,
    padding: 8,
  },
}));

interface CollaboratorsProps {
  collaborators: Collaborator[];
  isGridView: boolean;
}

export const Collaborators: React.FC<CollaboratorsProps> = ({
  collaborators,
  isGridView,
}) => {
  const isFewCollaborators = collaborators.length <= 2;

  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        ...styles.contributorsContainer,
        justifyContent: isGridView ? "flex-end" : "flex-start",
        transform: "scale(0.8)",
      }}
    >
      {isFewCollaborators ? (
        <AvatarGroup max={2} sx={collaboratorsStyles.avatarGroup}>
          {collaborators.map((el) => {
            const userProfileRoute = `/user-profile/${el.getUsername()}`;
            return (
              <CustomizedTooltip
                key={el.getUserId()}
                title={
                  <Box sx={collaboratorsStyles.customizedTooltipBox}>
                    {el.getUsername()}
                  </Box>
                }
                placement="top"
                enterTouchDelay={0}
              >
                <NavLink
                  to={userProfileRoute}
                  state={{ userId: el.getUserId() }}
                  style={collaboratorsStyles.userProfileNavLink}
                >
                  <StyledProfilePic
                    style={collaboratorsStyles.stylesProfilePic}
                    variant="rounded"
                    alt={el.getUsername()}
                    src={el.getProfilePicture()}
                  />
                </NavLink>
              </CustomizedTooltip>
            );
          })}
        </AvatarGroup>
      ) : (
        <CustomizedTooltip
          title={
            <Box sx={collaboratorsStyles.customizedTooltip}>
              {collaborators.map((el) => (
                <Box
                  key={el.getUserId()}
                  sx={collaboratorsStyles.collaboratorBox}
                >
                  <NavLink
                    to={`/user-profile/${el.getUsername()}`}
                    state={{ userId: el.getUserId() }}
                    style={collaboratorsStyles.userProfileNavLink}
                  >
                    <StyledProfilePic
                      variant="rounded"
                      alt={el.getUsername()}
                      src={el.getProfilePicture()}
                      style={{ margin: "auto" }}
                    />
                    <Box sx={collaboratorsStyles.userNameBox}>
                      {el.getUsername()}
                    </Box>
                  </NavLink>
                </Box>
              ))}
            </Box>
          }
          placement="top"
          enterTouchDelay={0}
        >
          <AvatarGroup max={2} sx={collaboratorsStyles.avatarGroup}>
            {collaborators.map((el) => {
              const userProfileRoute = `/user-profile/${el.getUsername()}`;
              return (
                <NavLink
                  to={userProfileRoute}
                  state={{ userId: el.getUserId() }}
                  style={collaboratorsStyles.userProfileNavLink}
                  key={el.getUserId()}
                >
                  <StyledProfilePic
                    style={collaboratorsStyles.stylesProfilePic}
                    variant="rounded"
                    alt={el.getUsername()}
                    src={el.getProfilePicture()}
                  />
                </NavLink>
              );
            })}
          </AvatarGroup>
        </CustomizedTooltip>
      )}
    </Box>
  );
};
